import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Reveal } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  const DOCS = [
    { id: "privacy", path: "/privacy", label: t("footerPrivacy") },
    { id: "terms", path: "/terms", label: t("footerTerms") },
    { id: "disclosure", path: "/affiliate-disclosure", label: t("footerDisclosure") },
    { id: "responsible", path: "/responsible-gaming", label: t("footerResponsible") },
  ];
  return (
    <footer data-testid="footer-section" className="px-6 pb-[calc(118px+env(safe-area-inset-bottom))] pt-5">
      <Reveal>
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <div className="flex items-start gap-3">
            <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-[#1663E6]" strokeWidth={1.75} />
            <p className="text-xs leading-relaxed text-slate-500" data-testid="disclaimer-text">
              {t("disclaimerText")}
            </p>
          </div>
          <div className="my-4 h-px bg-slate-100" />
          <p
            data-testid="disclaimer-18plus-badge"
            className="text-center text-[11px] leading-relaxed tracking-wide text-[#0B3D91]"
          >
            {t("responsible")}
          </p>
        </div>

        <nav className="mt-5 grid grid-cols-2 gap-2.5" data-testid="footer-legal-links">
          {DOCS.map((d) => (
            <Link
              key={d.id}
              to={d.path}
              data-testid={`footer-${d.id}-button`}
              className="rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-left text-[11px] font-medium text-slate-600 transition-colors hover:border-[rgba(22,99,230,0.4)] hover:text-[#0B3D91]"
            >
              {d.label}
            </Link>
          ))}
        </nav>

        <p className="mt-5 text-center text-[11px] text-slate-400" data-testid="footer-copyright">
          {t("copyright")}
        </p>
      </Reveal>
    </footer>
  );
}
